import { EMPTY_ROOT_CONTAINER_PROPS } from "@client/content/lib/consts";
import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { setShowingDetailId } from "../actions";
import { localStateSelector } from "../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

const INVISIBLE_PROPS: MapProps = {
  ...EMPTY_ROOT_CONTAINER_PROPS,
  isVisible: false,
  status: "None",
  title: ""
};

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);
    if (!localState.showingDetailId) return INVISIBLE_PROPS;

    const detail = localState.detail[localState.showingDetailId]!;

    return {
      ...props,
      isVisible: true,
      status: detail.status,
      title: localState.tickets.find((x) => x.ticketId === localState.showingDetailId)!.subject
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onClose: () => dispatch(setShowingDetailId({ ...getEntityRef(props), ticketId: null }))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
